import { useSelector } from "react-redux"

import PracticesUploadItem from "./PracticesUploadItem"
import GlobalPracticesUpload from "./GlobalPracticesUpload"
import { checkIfLopIsRequired, returnPractice } from "../../../../../lib/script"
import PracticesUploadItemRecords from "./PracticesUploadItemRecords"
import { changeWordingForWC } from "../../../../../lib/misc"
import { practicesFunctions } from "../../../../../lib/practices"

export default function PracticesUpload({caseAttorneyId, attyData, uploadPermission, updatePermission, activeCase: propActiveCase}) {
    const storeCase = useSelector(state => state.case.activeCase)
    const activeCase = propActiveCase ?? storeCase


    return <>
         <table className="table-border-radius-8">
            <thead>
                <tr>
                    <th>Practice Type</th>
                    {/* <th>{isCaseType(activeCase) == 'WC' ? 'WC-207' : 'HIPAA'}</th> */}
                    <th>{changeWordingForWC(activeCase, 'HIPAA', 'WC-207')}</th>
                    {checkIfLopIsRequired(attyData, activeCase) && <th>LOP</th>}
                    <th>Records</th>
                </tr>
            </thead>
            <tbody>
                {activeCase?.practices?.map(item => (
                    <tr key={item.id}>
                        <td>{returnPractice(item.practice_id)?.name }</td>
                        {practicesFunctions.isPracticeRequiresHIPAA(item.practice_id) ? <td className={'table-cell-no-padding'}>
                            <PracticesUploadItem practiceId={item.practice_id} usedFor={'HIPAA'} caseAttorneyId={caseAttorneyId} activeCase={activeCase} uploadPermission={uploadPermission} updatePermission={updatePermission} btnRed={true}/>
                        </td> : <td></td>}
                        {checkIfLopIsRequired(attyData, activeCase) && <>
                            {practicesFunctions.isPracticeRequiresLOP(item.practice_id) ? <td className="table-cell-no-padding">
                                <PracticesUploadItem practiceId={item.practice_id} usedFor={'LOP'} caseAttorneyId={caseAttorneyId} activeCase={activeCase} uploadPermission={uploadPermission} updatePermission={updatePermission} />
                            </td> : <td></td>}
                        </>}
                        <td className="table-cell-no-padding">
                            <PracticesUploadItemRecords practiceId={item.practice_id} usedFor={'Records'} caseAttorneyId={caseAttorneyId} uploadPermission={uploadPermission} updatePermission={updatePermission} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

        <GlobalPracticesUpload caseAttorneyId={caseAttorneyId} activeCase={activeCase} uploadPermission={uploadPermission} updatePermission={updatePermission}/>
    </>
}
